import type { BoxRow } from "./providers";

/**
 * Поиск короба по набранному: чистая половина, которой не нужен ни браузер, ни
 * сервис.
 *
 * Задача владельца 10.09.26: наряд называет короб НОМЕРОМ («10956»), а открыть
 * его можно было только глазами по списку — да ещё и в пределах потолка
 * страницы. Здесь набранное превращается в решение: открыть одно место, дать
 * выбрать из нескольких или честно сказать, что такого короба нет.
 */

/**
 * Набранное → то, что уедет в запрос.
 *
 * Пробелы внутри режутся намеренно: сканер кода места иногда добавляет их
 * сам, а «850 900 210956» и «850900210956» — один и тот же короб. Регистр не
 * трогаем — оба значения короба состоят из цифр.
 */
export function normalize(input: string): string {
  return input.replace(/\s+/g, "");
}

/**
 * Что делать с ответом поиска.
 *
 * `open` — короб один, и спрашивать нечего: сразу его карточка. `choose` —
 * несколько, и выбор обязан быть за человеком: `sortOrder` уникальным не
 * объявлен, и тихо открытый первый однажды окажется чужим. `none` — такого
 * короба на складе нет.
 */
export type FindOutcome =
  | { kind: "open"; place_id: number }
  | { kind: "choose"; rows: BoxRow[] }
  | { kind: "none" };

export function outcome(rows: readonly BoxRow[]): FindOutcome {
  const only = rows.length === 1 ? rows[0] : undefined;
  if (only) return { kind: "open", place_id: only.place_id };
  if (rows.length === 0) return { kind: "none" };
  return { kind: "choose", rows: [...rows] };
}

/**
 * Чего не нашли и где искали — фразой, которую человек может проверить.
 *
 * Город назван ОБЯЗАТЕЛЬНО, когда он был отбором: короб 10956 зовётся в CRM
 * «Невиномыск Невиномыск Короб 10956», а в справочнике локаций стоит Ростовом
 * (замер 09.09.26), и «короба нет» без имени города отправило бы человека
 * искать ошибку в номере, которой там нет.
 */
export function nothing(code: string, city: string): string {
  return city
    ? `Короба ${code} в городе ${city} нет`
    : `Короба ${code} на складе нет`;
}
